var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{attrs:{"align":"center","justify":"center"}},[_c('img',{style:({
      height: _vm.$vuetify.breakpoint.mdAndUp ? '5rem' : '4rem'
    }),attrs:{"src":require("@/../public/img/icons/mstile-150x150.png"),"alt":"logo"}}),_c('h1',{staticClass:"text-xs-center"},[_vm._v(_vm._s(_vm.$t('welcome')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }